var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSnorkel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.7,
    x2: 31.093,
    xlinkHref: "#lg1",
    y1: 230.823,
    y2: 230.823
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 1 921 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 423.7,
    x2: 442.093,
    xlinkHref: "#lg1",
    y1: 230.823,
    y2: 230.823
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.803,
    x2: 277.803,
    xlinkHref: "#lg2",
    y1: 253.009,
    y2: 253.009
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8679,
    stopColor: "#239f85",
    stopOpacity: 0.868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.299,
    x2: 102.087,
    xlinkHref: "#lg3",
    y1: 125.916,
    y2: 63.173
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.002,
    x2: 113.887,
    xlinkHref: "#lg2",
    y1: 59.924,
    y2: 98.023
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.313,
    x2: 248.742,
    xlinkHref: "#lg3",
    y1: 457.751,
    y2: 457.751
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(0 1 1 0 -159.615 159.615)",
    gradientUnits: "userSpaceOnUse",
    x1: 292.841,
    x2: 303.726,
    xlinkHref: "#lg2",
    y1: 382.449,
    y2: 420.548
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.632,
    x2: 285.72,
    xlinkHref: "#lg1",
    y1: 316.149,
    y2: 316.149
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.141,
    x2: 137.294,
    xlinkHref: "#lg3",
    y1: 453.952,
    y2: 326.148
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.614,
    x2: 274.47,
    y1: 154.702,
    y2: 361.053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 509.051,
    y2: -7.756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.011,
    x2: 256.51,
    y1: 183.93,
    y2: 281.426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.244,
    x2: 459.402,
    xlinkHref: "#lg2",
    y1: 89.084,
    y2: 157.242
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.739,
    x2: 519.934,
    xlinkHref: "#lg2",
    y1: 76.117,
    y2: 124.312
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.114,
    x2: 476.309,
    xlinkHref: "#lg2",
    y1: 24.837,
    y2: 73.032
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.184,
    x2: 73.885,
    y1: 277.817,
    y2: 199.518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.123 263.681h-24.938c-8.939 0-16.185-7.246-16.185-16.185v-33.346c0-8.939 7.246-16.185 16.185-16.185h24.938z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.877 263.681h24.938c8.939 0 16.185-7.246 16.185-16.185v-33.346c0-8.939-7.246-16.185-16.185-16.185h-24.938z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m250.59 484.964h-56.785c-62.861 0-114.002-51.141-114.002-114.002v-322.694c0-15.03 12.184-27.214 27.214-27.214s27.214 12.184 27.214 27.214v322.694c0 32.85 26.725 59.575 59.574 59.575h56.785c15.03 0 27.214 12.184 27.214 27.214s-12.185 27.213-27.214 27.213z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.231 78.936h-54.428v12.006l54.428 54.428z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.758 92.09h-46.635c-4.824 0-8.735-3.911-8.735-8.735v-15.792c0-4.824 3.911-8.735 8.735-8.735h46.634c4.824 0 8.735 3.911 8.735 8.735v15.792c0 4.824-3.91 8.735-8.734 8.735z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.59 430.537h-2.04v54.428h2.04c15.03 0 27.214-12.184 27.214-27.214s-12.185-27.214-27.214-27.214z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 480.212v-46.634c0-4.824-3.911-8.735-8.735-8.735h-15.792c-4.824 0-8.735 3.911-8.735 8.735v46.634c0 4.824 3.911 8.735 8.735 8.735h15.792c4.824-.001 8.735-3.911 8.735-8.735z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m231.941 268.8-51.78 101.534c-2.183 4.281 2.451 8.822 6.764 6.628l12.111-6.161c35.119-17.866 76.808-17.866 111.927 0l12.103 6.157c4.315 2.195 8.952-2.348 6.768-6.632l-51.776-101.526c-9.543-18.712-36.574-18.712-46.117 0z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.803 370.801v.162c0 6.809.602 13.48 1.752 19.964l92.287 92.287c6.484 1.15 13.154 1.752 19.963 1.752h56.785c15.03 0 27.214-12.184 27.214-27.214s-12.184-27.214-27.214-27.214h-56.785c-32.849 0-59.574-26.725-59.574-59.575v-.162z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.972 239.111v68.655c0 49.553-39.256 89.723-87.682 89.723-33.112 0-63.4-19.087-78.301-49.345l-32.811-56.723c-11.248-22.835-43.107-22.835-54.355 0l-32.811 56.723c-14.901 30.258-45.189 49.345-78.301 49.345-48.425 0-87.682-40.17-87.682-89.723v-68.655c0-49.553 39.256-89.723 87.682-89.723h276.58c48.424 0 87.681 40.17 87.681 89.723z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.29 385.394c-28.714 0-54.578-15.928-67.5-41.57l-32.811-55.433c-7.272-14.427-21.825-23.389-37.979-23.389s-30.707 8.962-37.978 23.388l-32.812 55.433c-12.922 25.642-38.786 41.57-67.5 41.57-41.679 0-75.587-33.908-75.587-75.587v-67.093c0-41.679 33.908-75.587 75.587-75.587h276.58c41.679 0 75.587 33.908 75.587 75.587v67.093c0 41.68-33.908 75.588-75.587 75.588z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.446 370.602c-23.449 0-44.571-13.008-55.123-33.947l-31.899-53.893c-9.082-18.015-27.253-29.205-47.424-29.205-20.172 0-38.343 11.19-47.422 29.204l-31.901 53.893c-10.553 20.94-31.674 33.948-55.123 33.948-34.036 0-61.727-27.691-61.727-61.727v-65.228c0-34.036 27.691-61.727 61.727-61.727h268.892c34.036 0 61.727 27.691 61.727 61.727v65.228c0 34.036-27.69 61.727-61.727 61.727z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 415.624,
    cy: 113.464,
    fill: "url(#SVGID_13_)",
    r: 29.729
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.978,
    cy: 93.356,
    fill: "url(#SVGID_14_)",
    r: 21.022
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.353,
    cy: 42.076,
    fill: "url(#SVGID_15_)",
    r: 21.022
  })), /*#__PURE__*/React.createElement("path", {
    d: "m183.209 210.886c26.17 26.17 25.457 69.313-1.592 96.363-27.05 27.05-70.193 27.763-96.363 1.592-26.17-26.17-25.457-69.313 1.592-96.363s70.192-27.762 96.363-1.592z",
    fill: "url(#SVGID_16_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSnorkel);
export default __webpack_public_path__ + "static/media/icon-snorkel.523e85e52ab85d3d4dd781cdb90976a2.svg";
export { ForwardRef as ReactComponent };